import { IconProps } from 'types/icon.type'

export const CheckThinIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Check thin icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2842 4.53285C17.5496 4.76215 17.5735 5.1572 17.3376 5.4152L8.19609 15.4152C8.07411 15.5486 7.89927 15.625 7.71565 15.625C7.53204 15.625 7.35718 15.5487 7.23517 15.4153L2.66245 10.4153C2.42653 10.1574 2.45038 9.76232 2.7157 9.53296C2.98103 9.3036 3.38737 9.32678 3.62328 9.58473L7.71548 14.0593L16.3766 4.58481C16.6125 4.32681 17.0188 4.30354 17.2842 4.53285Z"
        fill="currentColor"
      />
    </svg>
  )
}
